import axios from 'axios';
import apiConfig from '../api.config';

export default function getActiveDashboardAlerts() {
  const {
    host,
    URIs: { getActiveDashboardAlerts },
  } = apiConfig;

  const uri = `${host}${getActiveDashboardAlerts}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data.alerts || [];
    });
}
